// make header shrink on scroll

document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector("header"); // or your specific header selector
  const shrinkPoint = 50; // pixels scrolled before shrink activates

  if (!header) return;

  window.addEventListener("scroll", function() {
    if (window.scrollY > shrinkPoint) {
      header.classList.add("shrink");
    } else {
      header.classList.remove("shrink");
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__inline-menu li.has-submenu > a');

  menuItems.forEach(item => {
    item.addEventListener('click', function(e) {
      if (window.innerWidth < 768) { // mobile breakpoint
        e.preventDefault();
        const submenu = item.nextElementSibling;
        if (submenu) {
          submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
        }
      }
    });
  });
});

// Fancybox init
// $(document).ready(function () {
//   $('[data-fancybox]').fancybox({
//     animationEffect: "fade",
//     buttons: ["zoom", "close"]
//   });
// });

// Toggle `.is-stuck` on the Searchanise filter bar when it actually pins to the top.
// `.snize-sticky-position` is always present once Sticky filters is enabled in the app, so it can't be used as a stuck/unstuck signal.
(() => {
  let stickyEl = null;
  const checkStuck = () => {
    if (!stickyEl || !document.body.contains(stickyEl)) {
      stickyEl = document.querySelector('.snize-horizontal-wrapper');
    }
    if (!stickyEl) return;
    const stickyTop = parseFloat(getComputedStyle(stickyEl).top) || 0;
    stickyEl.classList.toggle('is-stuck', stickyEl.getBoundingClientRect().top <= stickyTop + 1);
  };
  window.addEventListener('scroll', checkStuck, { passive: true });
  new MutationObserver(() => { stickyEl = null; checkStuck(); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', checkStuck);
  checkStuck();
})();
